import { Alert, Button, Select } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateFromString } from "../../../../../../utils/dateFromString";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetInicioAsignacion, startGetUsuariosAsignacion, startSetUsuarioAsistencia } from "../../../../../../context/actions/detalleActions";

export const InicioAsignacion = () => {
  const dispatch = useDispatch();
  const { fechaIniciaAsignacion, usuarioIniciaAsignacion } = useSelector(
    (state) => state.detalleReducer.asistencia
  );
  const { asistenciaID } = useParams();
  const [selectedOption, setSelectedOption] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsuarios = async () => {
      setLoading(true);
      const result = await dispatch(startGetUsuariosAsignacion());
      if (result?.code === 0 && result?.data) {
        const opciones = result.data.map((usuario) => ({
          value: usuario.usuarioID,
          label: usuario.nombre,
        }));
        setUsuarios(opciones);
      }
      setLoading(false);
    };
    fetchUsuarios();
  }, [dispatch]);

  const handleTomoServicio = () =>
    dispatch(startSetInicioAsignacion(asistenciaID));

  const handleSelectOk = async () => {
    const result = await dispatch(
      startSetUsuarioAsistencia({ asistenciaID, usuarioID: selectedOption })
    );
    if (result?.code === 0) {
      setSelectedOption(null);
    }
  };

  //
  return (
    <>
      {fechaIniciaAsignacion ? (
        <Alert
          style={{ marginTop: 20, marginBottom: 20 }}
          type="success"
          message={`Asignando: ${usuarioIniciaAsignacion.nombre}`}
          description={` ${dateFromString(fechaIniciaAsignacion).f1}`}
        />
      ) : (
        <Button
          onClick={handleTomoServicio}
          style={{ marginBottom: 20, width: "100%" }}
          type="primary"
        >
          Tomo el Servicio para asignar
        </Button>
      )}
      <div style={{ marginBottom: 20 }}>
        <Select
          showSearch
          placeholder="Asignar a operador"
          style={{ width: "100%", marginBottom: 8 }}
          value={selectedOption}
          onChange={setSelectedOption}
          options={usuarios}
          loading={loading}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
        {selectedOption && (
          <Button
            type="default"
            block
            onClick={handleSelectOk}
          >
            OK
          </Button>
        )}
      </div>
    </>
    );
};